import React, { useEffect, useState } from 'react'
import { func, string, bool } from 'prop-types'
import { locations, extractFlagTitle, extractFlagName } from 'services/utils/countries'
import { phoneNumberMaxLength } from 'services/utils/common'
import { phoneValidationError, ukMobileValidationError } from 'services/utils/validations/validation-messages'
import { FlagDropdown, InputBox } from '../'

const PhoneInput = ({
  countryCode,
  setCountryCode,
  phoneNumber,
  setPhoneNumber,
  error,
  isSms,
  isSigninDetail
}) => {
  const [flagTitle, setFlagTitle] = useState(extractFlagTitle(locations, countryCode))
  const [flagName, setFlagName] = useState(extractFlagName(locations, countryCode))
  const [enhancedPhoneNumber, setEnhancedPhoneNumber] = useState(phoneNumber)
  const validationError = isSms ? ukMobileValidationError : phoneValidationError
  const needPreparedZero = (countryCode) => {
    if (countryCode === '+44' || countryCode === '+92' || countryCode === '+353') return true
    return false
  }
  useEffect(() => {
    if (needPreparedZero(countryCode) && phoneNumber.length > 4 && !phoneNumber.startsWith('0')) setEnhancedPhoneNumber(`0${phoneNumber}`)
    else setEnhancedPhoneNumber(phoneNumber)
    setFlagTitle(extractFlagTitle(locations, countryCode))
    setFlagName(extractFlagName(locations, countryCode))
  }, [phoneNumber, countryCode])
  return (
    <div className="phone-input">
      <FlagDropdown
        titleCode={countryCode}
        titleFlag={flagTitle}
        titleName={flagName}
        list={locations}
        setCountryCode={setCountryCode}
        className="dropdown"
        isSigninDetail={isSigninDetail}
      />
      <InputBox
        type="tel"
        value={enhancedPhoneNumber}
        onChange={e => setPhoneNumber(e.target.value)}
        id="details-phone-number"
        containerStyle="phone-number-input"
        placeholder="Enter phone number"
        error={error}
        validation={() => validationError(enhancedPhoneNumber, countryCode)}
        maxLength={phoneNumberMaxLength(countryCode).toString()}
      />
    </div>
  )
}

PhoneInput.propTypes = {
  countryCode: string.isRequired,
  setCountryCode: func.isRequired,
  phoneNumber: string.isRequired,
  setPhoneNumber: func.isRequired,
  error: string,
  isSms: bool,
}

PhoneInput.defaultProps = {
  error: '',
  isSms: false,
}

export default PhoneInput
